var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4492 5.54807L17.6483 7.34893C17.4647 7.53253 17.1678 7.53253 16.9842 7.34893L12.6481 3.01282C12.4645 2.82921 12.4645 2.53233 12.6481 2.34873L14.449 0.547873C15.1795 -0.182624 16.367 -0.182624 17.1014 0.547873L19.4492 2.89562C20.1836 3.62612 20.1836 4.81367 19.4492 5.54807ZM11.1012 3.89566L0.842863 14.1539L0.0147001 18.9002C-0.0985864 19.5408 0.460033 20.0955 1.10069 19.9861L5.847 19.1541L16.1053 8.89586C16.2889 8.71226 16.2889 8.41537 16.1053 8.23177L11.7691 3.89566C11.5816 3.71206 11.2848 3.71206 11.1012 3.89566ZM4.84695 13.2749C4.6321 13.0601 4.6321 12.7163 4.84695 12.5015L10.8629 6.48561C11.0777 6.27076 11.4215 6.27076 11.6363 6.48561C11.8512 6.70046 11.8512 7.04423 11.6363 7.25908L5.62043 13.2749C5.40557 13.4898 5.06181 13.4898 4.84695 13.2749ZM3.43673 16.5602H5.31182V17.9783L2.79217 18.4197L1.57727 17.2048L2.0187 14.6852H3.43673V16.5602Z",
    fill: "#0D2645",
    fillOpacity: 0.37
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.6143fdf6a2fe6e86d5172dc8253c8fef.svg";
export { ForwardRef as ReactComponent };